<template>
  <layout-content
    :nav-menu-items="navMenuItems"
  >
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }">
      <div class="navbar-content-container">
        <!-- Left Content: Menu Toggle -->
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="toggleVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
        </div>

        <!-- Middle Content: Dev Banner + Scribe Mode -->
        <div class="d-flex align-center right-row">
          <!-- Dev Mode Banner -->
          <template v-if="isDevMode()">
            <img
              src="@/assets/images/logos/blackWhiteCat.png"
              style="width: 50px; height: 50px;"
              alt="Cute Kitten"
              class="me-2"
            >
            <div class="font-weight-bold text-uppercase">
              DEV MODE
            </div>
          </template>

          <!-- Scribe Mode Banner -->
          <div
            v-if="$scribeProvider.id"
            class="scribe-banner ms-4 d-flex align-center"
            style="white-space: nowrap;"
          >
            <v-icon color="primary" :size="20">
              {{ icons.mdiPen }}
            </v-icon>
            <strong class="ms-1 me-1">Scribe Mode</strong> — Acting as:
            <span class="text-primary ms-1">
              {{ $scribeProvider.name }}
            </span>
          </div>
        </div>


        <!-- Right Content: User Menu -->
        <div class="d-flex align-center right-row">
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span>
          &copy; {{ new Date().getFullYear() }} {{ appName }}
          <span class="d-none d-md-inline">, All rights reserved</span>
        </span>
        <span>v{{ appVersion }}</span>
      </div>
    </template>
  </layout-content>
</template>

<script>
import { mdiMenu, mdiPen } from '@mdi/js'
import themeConfig from '@themeConfig'
import LayoutContent from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import getNavMenuItems from '@/navigation/default'
import { mapState } from 'vuex'

// App Bar Components
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'

export default {
  components: {
    LayoutContent,
    AppBarUserMenu, // App Bar Components
  },

  setup() {
    return {
      icons: { mdiMenu, mdiPen },
      appName: themeConfig.app.name,
      appVersion: themeConfig.app.version,
    }
  },

  computed: {
    ...mapState('comments', { comments: 'items' }),

    // Menu items with dynamic comment badge
    navMenuItems() {
      const items = getNavMenuItems()
      const commentIndex = items.findIndex(x => x.to === 'list-comments')
      const userId = this.$authUser.user().id
      if (commentIndex !== -1) {
        items[commentIndex].badge = this.comments.filter(c => !c.is_read && c.created_by_user_id !== userId).length
      }

      return items
    },
  },

  mounted() {
    this.$store.dispatch('encounters/syncingModal', false)
    this.$store.dispatch('loading', false)
  },

  methods: {
    isDevMode() {
      return process.env.NODE_ENV === 'development'
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}
.scribe-banner {
  background-color: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.4);
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.8rem;
  color: #b58900;
  display: inline-block;
}
</style>
